module.exports = __webpack_public_path__ + "static/media/android.969211cf.png";